import axios from "axios";

class Service {
    getClientDivision = (queryParams) => {
        return axios.get(`api/lookup/divisions?$filter=${queryParams}`)
    };

    getLocations = (queryStr) => {
        return axios.get(`api/lookup/locations?$filter=${queryStr}`);
    };

    getSchedules = (schId) => {
        return axios.get(`api/scheduling/schedule/${schId}`)
    };

    getAllSchedules = () => {
        return axios.get(`api/scheduling/schedule`)
    };

    getDepartments = (queryParams) => {
        return axios.get(`api/clientadmin/location/departments?$filter=${queryParams}`)
    };

    getSchedulesLookup = (queryParams) => { 
        return axios.get(`api/lookup/schedules?$filter=${queryParams}`)
     };

    getJobcatpositions = (clientId, Ids) => {
        return axios.get(`api/clients/${clientId}/jobcatpositions?$filter=jobCategoryId in (${Ids}) &$orderby=name`)
    };

    patchGenerateSchedule = (data)=>{
        return axios.patch(`api/scheduling/schedule/${data.scheduleId}/generate`,JSON.stringify(data))
    }

    postPublishSchedule = (data)=>{
        return axios.post(`api/scheduling/schedule/${data.scheduleId}/publish`,JSON.stringify(data))
    }

    getShiftSchedule = (finalQueryString, data) => {
        return axios.post(`api/scheduling/scheduler/excel?${`$count=true`}`, JSON.stringify(data));
    }

    postScheduleShift = (data)=>{
        return axios.post(`api/scheduling/schedule/${data.scheduleId}/shift`,JSON.stringify(data))
    }

    postScheduleUnAvailablity = (data)=>{
        return axios.post(`api/scheduling/schedule/${data.scheduleId}/unavailablity`,JSON.stringify(data))
    }

    patchScheduleShift = (data)=>{
        return axios.patch(`api/scheduling/schedule/${data.scheduleId}/shift`,JSON.stringify(data))
    }

    deleteAssignedScheduleShift = (data) => {
        return axios.patch(`api/scheduling/schedule/delete/${data.scheduleId}/shift`, JSON.stringify(data))
    }

    deleteGenerateSchedule = (scheduleId, genId)=>{
        return axios.delete(`api/scheduling/schedule/${scheduleId}/generate/${genId}`)
    }

    deletePublishSchedule = (scheduleId, pubId)=>{
        return axios.delete(`api/scheduling/schedule/${scheduleId}/publish/${pubId}`)
    }

    deleteGenerateUnAvailablity = (scheduleId, avaId)=>{
        return axios.delete(`api/scheduling/schedule/${scheduleId}/unavailablity/${avaId}`)
    }

    getShiftTypeLookup = () => {
        return axios.get(`api/scheduling/shifttype`);
    }
}

export default new Service();